module.exports = __webpack_public_path__ + "static/media/undraw_working_remotely_jh40.b5a861a5.svg";